import { Fragment } from 'react'

// Captures the URL so `split` hands back the links along with the text. The
// left boundary keeps `foohttps://evil.com` from reading as a link.
const LINK_IN_TEXT = /(?<![\w@])(https?:\/\/[^\s<>]+)/i

// A sentence's own punctuation is not part of the address it ends on.
const TRAILING_PUNCTUATION = /[.,;:!?\]}'"]+$/

// Takes the bubble's own text colour, so the link reads on the dark user bubble
// and the white staff bubble without a second class.
const THREAD_LINK =
  'underline decoration-current/50 underline-offset-2 transition-colors hover:decoration-current'

const trimTrailingPunctuation = (url: string) => {
  let trimmed = url.replace(TRAILING_PUNCTUATION, '')

  // Wikipedia's `..._(bar)` owns its bracket. A link written inside `(...)` does not.
  while (
    trimmed.endsWith(')') &&
    trimmed.split(')').length > trimmed.split('(').length
  ) {
    trimmed = trimmed.slice(0, -1).replace(TRAILING_PUNCTUATION, '')
  }

  return trimmed
}

export const firstLinkIn = (text: string): string | null => {
  const match = text.match(LINK_IN_TEXT)
  return match ? trimTrailingPunctuation(match[1]) : null
}

export const LinkedText = ({ text }: { text: string }) => (
  <>
    {text.split(LINK_IN_TEXT).map((chunk, chunkIndex) => {
      if (chunkIndex % 2 === 0) return chunk

      const url = trimTrailingPunctuation(chunk)
      return (
        // biome-ignore lint/suspicious/noArrayIndexKey: the split position is the chunk's identity
        <Fragment key={chunkIndex}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={THREAD_LINK}
          >
            {url}
          </a>
          {chunk.slice(url.length)}
        </Fragment>
      )
    })}
  </>
)
